import { useParams, useSearchParams } from "next/navigation";

import { useStore } from "@/store";

export function useShowPublicProfile() {
  const searchParams = useSearchParams();
  const preview = !!searchParams.get("preview");
  const { teamPermalink } = useParams<{ [key: string]: string }>();

  const { doc, teams } = useStore();
  const currentPermalink = teamPermalink || doc?.team?.permalink;
  const teamIsOurs = !!teams.userTeams.find((userTeam) => userTeam.permalink === currentPermalink);
  const showPublicProfile =
    !!currentPermalink && (preview || (teams.userTeams.length > 0 && !teamIsOurs));

  return showPublicProfile;
}
